import { OK } from "helpers/data-statuses"
export interface GoalValue {
  inputValue: number | undefined
  displayValue: string
}

export function computeGoalValue(value: number | undefined, status: string): GoalValue {
  if (status !== OK || value === undefined) {
    return { inputValue: undefined, displayValue: "-" }
  }

  const inputValue = parseFloat((value * 100).toFixed(2))
  const displayValue = (value * 100).toFixed(2)
  return { inputValue, displayValue }
}
